import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root', 'text', 'link']);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "text" | "link")[]
 * }>} PromoBannerItemStyles
 */

export const promoBannerItemStyles = helpers.defineMultiStyleConfig({
  /**
   * Base styles for PromoBannerItem component
   *
   * @param {Object} args - Component arguments
   * @param {Contentful.PromoBannerItem} args.component - PromoBannerItem component data
   *
   * @returns {PromoBannerItemStyles} - Component styles
   */
  baseStyle({component}) {
    return {
      root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        // KL-980 — text colour is controlled at the parent banner level; inherit it.
        color: 'inherit',
      },
      text: {
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '120%',
        textAlign: 'center',
        whiteSpace: 'nowrap',
      },
      link: {
        // Style the wrapper span and its nested link
        'fontSize': '12px',
        'fontStyle': 'normal',
        'fontWeight': 600,
        'lineHeight': '120%',
        // Apply underline to anchor element inside
        '& a, & a span': {
          textDecoration: 'underline',
          textUnderlineOffset: '2px',
        },
        '& a:hover, & a:hover span': {
          textDecoration: 'underline',
          opacity: 0.8,
        },
        '& p': {
          'fontSize': '12px',
          'fontStyle': 'normal',
          'fontWeight': 600,
          'lineHeight': '120%',
        },
      },
    };
  },

  variants: {
    default: {},
  },
});
